import React from "react";
import { InlineEditor } from "@hid-galaxy-ui/galaxy-react";
import IToolBarConfig from "@hid-galaxy-ui/galaxy-react/components/InlineEditor/IToolbarConfig";
import "./NotesSection.scss";

interface NotesSectionProps {
  notes: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

/** Shared with HistoryNotesTable (HID Notes) so toolbar matches partner notes. */
export const notesToolBarConfig: IToolBarConfig = {
  headingConfig: {
    isDisplayHeading: true,
    headings: [false, 1, 2, 3, 4, 5, 6],
  },
  fontStyleConfig: {
    isDisplayBold: true,
    isDisplayItalic: true,
    isDisplayUnderline: true,
    isDisplayStrike: true,
  },
  indentConfig: {
    isDisplayOrdered: true,
    isDisplayBullet: true,
    isDisplayIndent: false,
  },
  colorConfig: {
    isDisplayBackground: false,
    isDisplayColor: false,
  },
  alignmentConfig: {
    isDisplayJustify: false,
    isDisplayCenter: false,
    isDisplayRight: false,
  },
  miscConfig: {
    isDisplayImage: false,
    isDisplayLink: false,
    isDisplayCodeblock: false,
    isDisplayBlockquote: false,
  },
  buttonConfig: {
    buttonLabel: "",
    displayPostButton: false,
    isRequired: false,
  },
};

const NotesSection: React.FC<NotesSectionProps> = ({
  notes,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className={`notes-section${readOnly ? " notes-section--readonly" : ""}`}>
      <h3 className="notes-title">Add notes (Optional)</h3>
      <InlineEditor
        id="validation-notes"
        placeholder="Add notes here.."
        toolBarConfig={notesToolBarConfig}
        editorData={notes}
        handleOnChange={readOnly ? () => undefined : onChange}
        {...(readOnly ? { disabled: true } : {})}
      />
    </div>
  );
};

export default NotesSection;

